import React from 'react';

interface Props {
  loader: React.ReactNode;
  loading: boolean;
  children: React.ReactNode;
}

const Skeleton: React.FC<Props> = ({ loading, loader, children }) => {
  if (loading) return <>{loader}</>;

  return <>{children}</>;
};

export default Skeleton;
